import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as usersActions from '../../redux/actions/usersActions';

import CheckboxIcon from '../icons/CheckboxIcon';
import InputErrors from '../common/InputErrors';

class ResetPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password1: '',
      password2: '',
      staySignedIn: false,
      passwordsMatchError: false,
      noPassword1Error: false,
      noPassword2Error: false,
      serverErrors: [],
    };
  }

  login = (e) => {
    const { password1, password2, staySignedIn } = this.state;
    const { dispatchUsersActions, location } = this.props;
    e.preventDefault();
    this.resetErrors();
    if (!password1) {
      this.setState({ noPassword1Error: true });
    } else if (!password2) {
      this.setState({ noPassword2Error: true });
    } else if (password1 !== password2) {
      this.setState({ passwordsMatchError: true });
    } else {
      dispatchUsersActions.setPassword({
        userKey: location.search.substring(1), // remove leading '?'
        password: password1,
        staySignedIn,
      }, this.onFail);
    }
  }

  resetErrors = () => {
    this.setState({
      passwordsMatchError: false,
      noPassword1Error: false,
      noPassword2Error: false,
      serverErrors: [],
    });
  }

  onFail = (error) => {
    this.setState({
      serverErrors: error.response
        ? error.response.data
        : ['There was a problem connecting to the server.'],
    });
  }

  handleInputChange = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    this.setState({ [name]: value });
  }

  render() {
    const { serverErrors, noPassword1Error, noPassword2Error, passwordsMatchError, password1, password2, staySignedIn } = this.state;
    const { location, loggedIn } = this.props;

    // Aggregate error messages
    let errors = serverErrors;
    if (noPassword1Error || noPassword2Error) errors = [...errors, 'All fields are required.'];
    if (passwordsMatchError) errors = [...errors, 'Your new passwords must match.'];

    // Jump out if there's no user key in the query params
    if (!location.search.length) return <Redirect to="/" />;
    // TO DO: Probably add in a loading state while waiting for the database to respond
    return loggedIn ? (
      // After login, redirect to the dashboard
      <Redirect to="/" />
    ) : (
      <Fragment>
        <Helmet>
          <title>Reset Password</title>
        </Helmet>
        <div className="fullscreen-form fullscreen-form--muted">
          <div className="row fullscreen-form__content">
            <h1 className="fullscreen-form__heading">
              Reset Password
            </h1>
            <div className="fullscreen-form__subheading">
              Please create a new password.
            </div>
            <form className="form fullscreen-form__form">
              {errors.length !== 0 && <InputErrors errors={errors} />}
              <label htmlFor="password1">
                Password
              </label>
              <input
                name="password1"
                id="password1"
                value={password1}
                onChange={this.handleInputChange}
                type="password"
              />
              <label htmlFor="password2">
                Confirm Password
              </label>
              <input
                name="password2"
                id="password2"
                value={password2}
                onChange={this.handleInputChange}
                type="password"
              />
              <div className="fullscreen-form__options">
                <div />
                <label className="fullscreen-form__checkbox">
                  <input
                    name="staySignedIn"
                    type="checkbox"
                    value={staySignedIn}
                    onChange={this.handleInputChange}
                  />
                  <CheckboxIcon value={staySignedIn} />
                  Stay signed in
                </label>
              </div>
              <div className="fullscreen-form__button-wrapper">
                <button
                  type="submit"
                  className="button button--large"
                  onClick={this.login}
                >
                  Save and Log In
                </button>
              </div>
            </form>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { loggedIn: state.users.currentUserId && sessionStorage.jwt };
}

function mapDispatchToProps(dispatch) {
  return { dispatchUsersActions: bindActionCreators(usersActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/components/pages/ResetPasswordPage.js